import { render, staticRenderFns } from "./student-add.vue?vue&type=template&id=f5eed774&"
import script from "./student-add.vue?vue&type=script&lang=js&"
export * from "./student-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports